import React from 'react';
import './PlacementBanner.css';

function PlacementBanner() {
  return (
    <div className='placement-banner-outer d-flex justify-content-start align-items-center banner-bottom-radius'>
      <div className="placement-banner-inner d-flex justify-content-end align-items-start flex-column">
        <h1 className="header-text">100% Placement Record</h1>
        <p className="cta-text">LIMS Hotel management Institute stands as the only institute in Siliguri to have 100% placements record.</p>
      </div>
    </div>
  )
}

export default PlacementBanner
